import { ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';
import { IconButton } from '@material-ui/core';
import DeleteIcon from '@mui/icons-material/Delete';
import Grid from '@material-ui/core/Grid';
import Input from '~/ui/components/inputs/Input';
import PhoneFlagInput from '~/ui/components/inputs/PhoneFlag';

interface IProps {
  index: number;
  onRemove?: (index: number) => void;
}

const SecondaryPhysician = ({ index, onRemove }: IProps): ReactElement => {
  const {
    register,
    control,
    setValue,
    formState: { errors },
  } = useFormContext();

  return (
    <Grid container spacing={3} alignItems="center">
      <Grid item xs>
        <Grid container spacing={3}>
          <Grid item xs={3}>
            <Input
              name={`secondaryPhysicians.${index}.name`}
              register={register}
              errors={errors}
              label="Name"
              required
            />
          </Grid>
          <Grid item xs={3}>
            <PhoneFlagInput
              name={`secondaryPhysicians.${index}.phone`}
              control={control}
              errors={errors}
              label="Phone"
              setValue={setValue}
            />
          </Grid>
          <Grid item xs={3}>
            <PhoneFlagInput
              name={`secondaryPhysicians.${index}.fax`}
              control={control}
              errors={errors}
              label="Fax"
              setValue={setValue}
            />
          </Grid>
          <Grid item xs={3}>
            <Input
              name={`secondaryPhysicians.${index}.specialty`}
              register={register}
              errors={errors}
              label="Specialty"
            />
          </Grid>
        </Grid>
      </Grid>
      {onRemove && (
        <Grid item>
          <IconButton title="Remove" onClick={() => onRemove(index)}>
            <DeleteIcon />
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
};

export default SecondaryPhysician;
